import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as menuItemActions from '../../../redux/menuItems/actions';
import Spin from '../../../components/loading';

const deleteRow = props => {
  props.deleteMenuItem(props.menuItemId).then(() => props.closeModal());
}

const DeleteMenuItem = props => {
  let { loading, error, message, failed } = props;
  return (
    <>
      <Modal
        id="financial-transaction-modal"
        size='xl' isOpen={props.isOpen}>
        <ModalHeader>
          <div className="row">
            <div className="col-11">{locales('titles.deleteMenuItem')}
            </div>
            <div className="col-1 text-left">
              <a
                href="#"
                className=""
                onClick={event => {
                  event.preventDefault();
                  props.closeModal();
                }}
              >
                <i className="fas fa-times"></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Spin spinning={loading}>
            <article>
              {error &&
                < div className="alert alert-danger">
                  {locales("messages.server.error")}
                </div>
              }
              {failed && <div className="alert alert-danger">{message}</div>}
              <div className='col-12 p-0'>
                <div className='col-12 p-0'>
                  {locales('titles.sureToDeleteMenuItem', { fieldName: props.title })} ؟
                </div>
              </div>
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-danger mx-1' onClick={() => deleteRow(props)}>{locales('labels.yes')}</button>
          <button className='btn btn-success mx-1' onClick={() => props.closeModal()}>{locales('labels.no')}</button>
        </ModalFooter>
      </Modal >
    </>

  )
};
const mapStateToProps = (state) => {
  return {
    loading: state.menuItemsReducer.deleteMenuItemLoading,
    error: state.menuItemsReducer.deleteMenuItemError,
    failed: state.menuItemsReducer.deleteMenuItemFailed,
    message: state.menuItemsReducer.deleteMenuItemMessage,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    deleteMenuItem: id => dispatch(menuItemActions.deleteMenuItem(id))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteMenuItem)